import defaultLocales from 'globals/locales/default';

const {
  customer,
  reference,
  send,
  opened,
  invitedBy,
  emailStatus,
} = defaultLocales;

const now = new Date();
now.setSeconds(now.getSeconds() + 10);

export const headLabelsLongVersion = [
  customer,
  reference,
  send,
  opened,
  invitedBy,
  emailStatus,
  '',
];
export const dummyPagination = {
  itemsPerPage: 10,
  currentPage: 1,
  numberOfPages: 100,
};
